export var getStaticFolderIdentity = function (item) {
    var _a;
    return String((_a = item === null || item === void 0 ? void 0 : item.logical_Uoi_Id) !== null && _a !== void 0 ? _a : '');
};
export var getMediaActionIdentity = function (item) {
    var _a, _b;
    return String((_b = (_a = item === null || item === void 0 ? void 0 : item.uoi_Id) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.uoi_id) !== null && _b !== void 0 ? _b : '');
};
